import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, ArrowRight } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui';
import '../styles/theme.css';

const Login: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      await login({ username, password });
      navigate('/admin');
    } catch (err: any) {
      setError(err?.response?.data?.detail || 'Incorrect username or password.');
    } finally { setBusy(false); }
  };

  return (
    <div className="mx-app" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center',
      background: 'var(--mx-surface-2)', padding: 24 }}>
      <div className="mx-card" style={{ width: 'min(400px, 100%)', boxShadow: 'var(--mx-shadow-md)' }}>
        <div className="mx-card-pad" style={{ padding: '30px 30px 26px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
            <span style={{ display: 'grid', placeItems: 'center', width: 34, height: 34, borderRadius: 9,
              background: 'var(--mx-accent)', color: '#fff' }}><ShieldCheck size={19} /></span>
            <span style={{ fontSize: 20, fontWeight: 700, letterSpacing: '-0.01em' }}>DocShawk</span>
          </div>
          <p className="mx-muted" style={{ fontSize: 13.5, margin: '0 0 22px' }}>
            Sign in to review your documents.</p>

          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div>
              <label className="mx-subtle" style={{ fontSize: 12, fontWeight: 600 }}>Username</label>
              <input className="mx-input" type="text" autoFocus autoComplete="username"
                placeholder="username" value={username}
                onChange={(e) => setUsername(e.target.value)} style={{ marginTop: 5 }} />
            </div>
            <div>
              <label className="mx-subtle" style={{ fontSize: 12, fontWeight: 600 }}>Password</label>
              <input className="mx-input" type="password" autoComplete="current-password"
                placeholder="••••••••" value={password}
                onChange={(e) => setPassword(e.target.value)} style={{ marginTop: 5 }} />
            </div>
            {error && <div style={{ fontSize: 12.5, color: 'var(--mx-danger)' }}>{error}</div>}
            <Button icon={ArrowRight} variant="primary" type="submit" loading={busy}
              disabled={!username || !password} style={{ justifyContent: 'center', marginTop: 4 }}>
              {busy ? 'Signing in…' : 'Sign in'}
            </Button>
          </form>
        </div>
        <div className="mx-card-pad" style={{ borderTop: '1px solid var(--mx-border)', padding: '12px 30px',
          display: 'flex', gap: 8, alignItems: 'center', color: 'var(--mx-text-subtle)', fontSize: 11.5 }}>
          <ShieldCheck size={13} /> Confidential documents are analyzed only within your firm’s approved systems.
        </div>
      </div>
    </div>
  );
};

export default Login;
